import { LINK_API_BASE_URL } from "constants/urls";
import { callApi } from "utils/_base";

export const resetPassword = (data) => {
  const route = LINK_API_BASE_URL + `/accounts/auth/password_reset/`;
  return callApi("POST", route, data);
};

export const emailVerify = (data) => {
  const route = LINK_API_BASE_URL + `/accounts/auth/email_verification/`;
  return callApi("POST", route, data);
};

export const loginHook = (data) => {
  const route = LINK_API_BASE_URL + `/accounts/auth/login/`;
  return callApi("POST", route, data);
};
